var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"position":"absolute"},attrs:{"fluid":""}},[_c('v-subheader',{staticClass:"ma-0",staticStyle:{"font-size":"32px"}},[_vm._v(" "+_vm._s(_vm.$t('WorkBench.Header'))+" ")]),_c('v-row',[_vm._t("navigation")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }